import { render, staticRenderFns } from "./Aprobacion.vue?vue&type=template&id=393b4e2f&"
import script from "./Aprobacion.vue?vue&type=script&lang=js&"
export * from "./Aprobacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports